module.exports = __webpack_public_path__ + "img/nsia.f897f015.png";